export function isE2E(): boolean {
  return window.localStorage.getItem("e2e") === "true";
}
